import { produce } from 'immer';
import { getType } from 'typesafe-actions';

import { getValidationErrorData } from '../common/helpers';
import { CreativeType } from '../common/typings';

import * as actions from './actions';
import { PresetsState } from './typings';

export const getInitialPresetsState = (creativeType: CreativeType = CreativeType.COMMON) => ({
    dataProvider: [],
    creativeType,
    error: undefined
});

export function presets(state: PresetsState = getInitialPresetsState(), action: actions.PresetsAction): PresetsState {
    return produce(state, draft => {
        switch (action.type) {
            case getType(actions.loadPresetsSuccess): {
                draft.dataProvider = action.items;

                return;
            }

            case getType(actions.loadPresets): {
                draft.error = undefined;

                return;
            }

            case getType(actions.showError): {
                draft.error = getValidationErrorData(action.error);

                return;
            }

            default:
                return;
        }
    });
}
